export default "__VITE_ASSET__hEgRPQt1__"